import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  headerContainer: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(10),

    [theme.breakpoints.up('md')]: {
      backgroundImage: 'url("/images/black-november-2023-header-bg.svg")',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '45% 50%',
    },
  },
  header: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  headerTextBox: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(0, 4),
    textAlign: 'center',

    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  headerPlanBox: {
    padding: theme.spacing(0, 6),
    textAlign: 'center',
    color: theme.palette.grey[800],
  },
  featuresBox: {
    position: 'relative',
    marginTop: -theme.spacing(8),
    padding: theme.spacing(8, 12),
    borderRadius: 15,
    border: `1px solid ${theme.palette.grey[400]}`,
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.common.white,
  },
  featuresBoxTitle: {
    position: 'relative',
    color: '#7833FF',

    '&::before': {
      display: 'block',
      position: 'absolute',
      top: 25,
      left: -40,
      content: '""',
      width: 30,
      height: 5,
      backgroundColor: '#7833FF',
    },
  },
  featuresBoxSubtitle: {
    marginTop: theme.spacing(4),
    color: theme.palette.grey[700],
  },
  featureGrid: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'flex-start',
    },
  },
  featureItem: {
    width: 300,
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: theme.spacing(4),
    marginLeft: 'auto',
    marginRight: 'auto',
    color: theme.palette.grey[700],

    '& div': {
      marginRight: theme.spacing(2),
    },

    [theme.breakpoints.up('sm')]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  infoContent: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-evenly',
    },
  },
  infoBox: {
    textAlign: 'center',
    color: theme.palette.grey[600],
  },
}));
